import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import burgerIcon from '../../assets/images/burger-icon.svg';
import closeIcon from '../../assets/images/close-icon.svg';
import profile from '../../assets/images/profile.png';
import user from '../../assets/images/user.svg';
import soccerball from '../../assets/images/soccerball.svg';
import srcard from '../../assets/images/srcard.svg';
import srbook from '../../assets/images/srbook.svg';
import clock from '../../assets/images/clock.svg';
import setting from '../../assets/images/setting.svg';
import Helpinfo from '../../assets/images/Helpinfo.svg';
import logout from '../../assets/images/logout.svg';
import logo from '../../assets/images/logo.png';
import screen8topimage from '../../assets/images/screen8topimage.png';
import mobilescreen from '../../assets/images/mobilescreen.png';
import list from '../../assets/images/list.png';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';
import SideMenu from '../../components/SideMenu';
import { useDispatch, useSelector } from 'react-redux';
import Template from '../Game/Template';
import { playDemoAct } from '../../store/actions/authActions';

const Landing = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    return (
        <>
            <div className='screen-8-section'>
                <div className='screen-8-content'>
                    <div className='screen-8-top-part'>
                        <div className='landing-logo-part'>
                            <div className='screen-1-logo-image'>
                                <img src={logo} alt="logo" className='img-fluid' />
                            </div>
                        </div>
                        <div className='screen-8-top-image'>
                            <img src={screen8topimage} alt="img" className='img-fluid' />
                        </div>
                        <div className='mobile-screen'>
                            <img src={mobilescreen} alt="mobilescreen" className='img-fluid' />
                        </div>
                        <div className='position-absolute w-25 top-0 end-0 me-2 start-play-btn-block'>
                            <Link className='p-1' to="/login">LOGIN</Link>
                        </div>
                        <div className='screen-8-main-title'>
                            <h1>Watch
                                Play
                                <span>Win!!</span></h1>
                        </div>
                    </div>
                    <div className='screen-8-center-part'>
                        <div className='screen-8-center-image'>
                            <img src={list} alt="list" className='img-fluid' />
                        </div>
                        <div className='screen-8-center-title'>
                            <h2>SIMPLE,
                                FAST,
                                FUN! <span>Win 3.5X!</span></h2>
                        </div>
                    </div>
                    <div className='screen-8-bottom-block'>
                        <div className='screen-8-bottom-part'>
                            <div className='screen-8-bottom-title'>
                                <h3><span>BALLHOG!</span> iT’S DIFFERENT.</h3>
                            </div>
                            <div className='screen-8-bottom-paragraph'>
                                <p>A new way to play and win. BallHog makes it simple to focus on your favorite team and play fantasy. Play with friends, fellow fans, or by yourself. But Play to WIN!</p>
                            </div>
                            <div className='start-play-btn-block'>
                                <Link to="/register">Start playing today <span><FontAwesomeIcon icon={faArrowRight} /></span></Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Landing